import { Type } from 'typebox'

import { StoredAuthenticationContext } from '../../authentication/authentication-context.js'
import type {
    MappedPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'

const AuthenticationContextStorageRecord = Type.Object({
    id: Type.Literal('current'),
    loginKind: StoredAuthenticationContext.properties.loginKind,
    namespace: StoredAuthenticationContext.properties.namespace,
    authenticatedAt: StoredAuthenticationContext.properties.authenticatedAt
})
const CurrentAuthenticationContextId = 'current'

type AuthenticationContextCollection = PersistenceCollection<
    StoredAuthenticationContext,
    'id'
>

export interface FamilyAuthenticationContextStore {
    clear(): Promise<void>
    get(): Promise<StoredAuthenticationContext | null>
    put(value: StoredAuthenticationContext): Promise<void>
}

export const AuthenticationContextCollectionDefinition: MappedPersistenceCollectionDefinition<
    typeof AuthenticationContextStorageRecord,
    StoredAuthenticationContext,
    'id'
> = {
    kind: 'authentication-context',
    scope: 'global',
    primaryKey: 'id',
    modelSchema: AuthenticationContextStorageRecord,
    encode: (value) => ({
        id: 'current',
        ...value
    }),
    decode: ({ id: _id, ...value }) => value
}

export class FamilyAuthenticationContextStoreAdapter
    implements FamilyAuthenticationContextStore {
    readonly #collection: AuthenticationContextCollection

    public constructor(collection: AuthenticationContextCollection) {
        this.#collection = collection
    }

    public async clear(): Promise<void> {
        await this.#collection.remove(CurrentAuthenticationContextId)
    }

    public async get(): Promise<StoredAuthenticationContext | null> {
        return await this.#collection.get(CurrentAuthenticationContextId)
    }

    public async put(value: StoredAuthenticationContext): Promise<void> {
        await this.#collection.put(value)
    }
}
